module.exports = __webpack_public_path__ + "img/legalServices-4.8f1f2b47.png";